import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Contact } from "../contact/contact";
import { Donation } from "../donation/donation";
import { OptionService } from 'option/option.service';
import { ContactComponent } from "../contact/contact.component";

@Component({
    selector: 'thankyou-order',
    templateUrl: 'thankyou-order.component.html'
})

export class ThankyouOrderComponent implements OnInit {
    /**
     * The current step
     */
    @Input() step: string;

    /**
     * type of the project
     */
    @Input() projectType: string;

    /**
     * The current donation
     */
    @Input() donation: Donation;

    /**
     * handling all contact data
     */
    @Input() contact: Contact;

    /**
     * form group for validation
     */
    @Input() form: FormGroup;

    /**
     * hold the available size of the application
     */
    @Input() size: string;

    /**
     * holds the version of the output (widget|page|form)
     */
    @Input() version: string;

    /**
     * Output emitter for changing the step
     * @type {Function}
     */
    @Output() stepChange: EventEmitter<any> = new EventEmitter();

    /**
     * Is the contact form mandatory.
     */
    contactMandatory: boolean;

    /**
     * Thank You page element order
     * with default order
     */
    thankyouOrder: Array<{ name: string, show: boolean, sort: number }> = [];

    /**
     * The constructor
     * @param optionService
     */
    constructor(protected optionService: OptionService) { }

    ngOnInit() {
        // get ordering from the backend
        this.thankyouOrder = this.optionService.getOption('thankyou_order');

        if (!this.thankyouOrder || this.thankyouOrder.length === 0) {
            // set default (all shown), if no settings is there
            this.thankyouOrder = [
                { name: "headline", show: true, sort: 1 },
                { name: "text", show: true, sort: 2 },
                { name: "media", show: true, sort: 3 },
                { name: "banktransfer", show: true, sort: 4 },
                { name: "newsletter", show: true, sort: 5 },
                { name: "address", show: true, sort: 6 },
                { name: "sharing", show: true, sort: 7 }
            ]
        }

        // sort the order
        this.thankyouOrder.sort((a, b) => {
            return a.sort - b.sort;
        });

        // check if the contact data should be requested manually
        this.contactMandatory = ContactComponent.isContactMandatory();
    }

    /**
     * Emit the step change
     * @param newStep
     */
    emitStepChange(newStep: string): void {
        this.stepChange.emit(newStep);
    }
}
